import React, { useState } from "react";
import OTPInput from "react-otp-input";
import { gAuthQROn, gAuthVerify } from "src/api/securityAuthApi";
import { BASE_PATH } from "src/config/constants";
import useLogout from "src/hooks/useLogout";
import { useAppSelector } from "src/redux/redux-hooks";
import { showErrorToast, showSuccessToast } from "src/utils/toast";

const MobileAppAuth: React.FC = () => {
  const { userData } = useAppSelector((state) => state.user);
  const [stage, setStage] = useState<"code" | "qr" | "NA">("NA");
  const [qrData, setQrData] = useState<{ qrcode: string } | null>(null);
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);

  const { handleLogout } = useLogout();

  const handle = {
    qrAuthOn: () => {
      gAuthQROn()
        .then((res) => {
          if (res?.data?.qrcode) {
            setQrData(res?.data);
            setStage("qr");

            setTimeout(() => {
              setShowOtp(true);
            }, 1000);
          } else {
            showErrorToast("Something went wrong");
          }
        })
        .catch((error) => {
          const message = error?.data?.status_message ?? "Something went wrong";

          showErrorToast(message);
        });
    },
    onChangeQrOtp: (otp: string) => {
      const nOtp = otp.replace(/\D/g, "");
      setOtp(nOtp);

      if (nOtp.length === 6 && userData?.admin_id) {
        gAuthVerify({ token: nOtp })
          .then((res) => {
            if (res.status_code === 200) {
              showSuccessToast("2-Step Verification is enabled for your account.");
              handleLogout();
            }
          })
          .catch((error) => {
            const message = error?.data?.status_message ?? "Something went wrong";
            console.warn(message);

            showErrorToast(
              "A previous authenticator setup was detected. Please delete the old entry from your authenticator app and scan the new QR code."
            );
          });
      }
    },
  };

  return (
    <div className="text-center">
      {stage === "NA" && (
        <>
          <div className="mt-3">
            If you haven't downloaded,
            <br />
            please download the <b>Google Authenticator</b> app
          </div>
          <div className="mt-3">Using this app, you will receive a verification code during login authentication.</div>
          <div
            className="d-flex align-items-center gap-2 mt-4 mb-2"
            style={{ justifyContent: "space-evenly", width: "100%" }}
          >
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
              style={{ borderRadius: "8px" }}
            >
              <img
                src={`${process.env.NODE_ENV === "development" ? "" : BASE_PATH}/playstore.en.png`}
                style={{ width: "200px", height: "55px" }}
                alt="Google Authenticator"
              />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://apps.apple.com/us/app/google-authenticator/id388497605"
              style={{ borderRadius: "8px" }}
            >
              <img
                src={`${process.env.NODE_ENV === "development" ? "" : BASE_PATH}/app-store-badge.en.png`}
                style={{ width: "200px", height: "55px" }}
                alt="Google Authenticator"
              />
            </a>
          </div>
          <div className="mt-4">
            <button type="button" className="btn btn-primary" onClick={handle.qrAuthOn}>
              Enable 2-Step Verification
            </button>
          </div>
        </>
      )}

      {stage === "qr" && (
        <div>
          <p>Scan the QR code with your authenticator app</p>
          <img src={qrData?.qrcode} alt="QR Code" />

          {showOtp && (
            <>
              <p className="mt-1">
                Once scanned, enter the code below
                <br />
                <small>Note: Please remove old authenticator entry and scan new QR</small>
              </p>
              <div className="login-form mt-1 login-auth">
                <OTPInput
                  value={otp}
                  onChange={handle.onChangeQrOtp}
                  numInputs={6}
                  inputType="tel"
                  renderInput={({ style, ...props }) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input {...props} autoComplete="off" type="tel" maxLength={1} />
                    </div>
                  )}
                />
              </div>
            </>
          )}
        </div>
      )}

      {/* <div className="mt-3">
        <div className="verify-code">273593</div>
      </div> */}

      {/* <div className="mt-3">
        <b>
          If you haven&apos;t downloaded,
          <br />
          please download &apos;Secure Auth Verification App&apos; from below link.
        </b>
      </div>

      <div className="mt-3">Using this app you will receive auth code during login authentication</div>

      <div className="mt-3">
        <a href="https://play.google.com/store/apps/details?id=online.realbingo.multiplayer.board.game">
          <button type="button" className="btn btn-primary">
            <i className="fab fa-android" /> <span>Download on the Android</span>
          </button>
        </a>
      </div> */}
    </div>
  );
};

export default MobileAppAuth;
